module.exports = __webpack_public_path__ + "static/media/signup_bg.e70c6562.webp";